export default __webpack_public_path__ + "static/media/aws-mobilehub.3b3a428f.svg";